import _ from 'lodash';
import React, { Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';

@inject('artistStore')
@observer
class FanStatusFilter extends React.Component {
	render () {
		const { tierFilter = {} } = this.props.artistStore;
		let tierValue = _(tierFilter).values().first() || '';
		tierValue = tierValue.toUpperCase().replace(/\s/g, '_');

		return (
			<Fragment>
				<div className="grid-x">
					<div className="cell auto">
						<nav>
							<ul className="menu horizontal artist-nav">
								<li>
									<NavLink
										data-ta="activeFansButton"
										isActive={ this.isActive('ACTIVE') }
										to={ `/manage-fans/ACTIVE/${tierValue}` }
									>
										Active Fans
									</NavLink>
								</li>
								<li>
									<NavLink
										data-ta="inactiveFansButton"
										isActive={ this.isActive('INACTIVE') }
										to={ `/manage-fans/INACTIVE/${tierValue}` }
									>
										Inactive Fans
									</NavLink>
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</Fragment>
			// <div className="grid-x grid-padding-x">
			// 	<div className="cell shrink">
			// 		<NavLink
			// 			data-ta="activeFansButton"
			// 			isActive={ this.isActive('ACTIVE') }
			// 			to={ `/manage-fans/ACTIVE/${tierValue}` }
			// 		>
			// 			Active Fans
			// 		</NavLink>
			// 	</div>
			// 	<div className="cell shrink">
			// 		<NavLink
			// 			data-ta="inactiveFansButton"
			// 			isActive={ this.isActive('INACTIVE') }
			// 			to={ `/manage-fans/INACTIVE/${tierValue}` }
			// 		>
			// 			Inactive Fans
			// 		</NavLink>
			// 	</div>
			// </div>
		);
	}

	isActive (filterSlug) {
		return () => {
			const { statusFilter = {} } = this.props.artistStore;
			const isStatusFilterSelected = _(statusFilter).values().first() === filterSlug;

			return isStatusFilterSelected;
		};
	}
}

export default FanStatusFilter;
